"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const StyledI = styled_components_1.default.i `
	border: solid #333;
	border-width: 0 5px 5px 0;
	display: inline-block;
	padding: 3px;
	height: 20px;
	width: 20px;
	cursor: pointer;

	&:hover {
		opacity: 0.4;
	}

	transform: ${({ direction }) => direction === "left" ? "rotate(135deg)" : "rotate(-45deg)"};

	${({ direction }) => direction === "left" ? "margin-left: 1em;" : "margin-right: 1em;"}
`;
const Arrow = ({ style, onClick, direction, className = "", }) => {
    return (react_1.default.createElement("a", { onClick: onClick, className: className },
        react_1.default.createElement(StyledI, { style: style, direction: direction })));
};
exports.default = Arrow;
